/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface KPIDetails { 
    paxBookedCabinGrade?: number;
    paxBookedCabinType?: number;
    paxBookedCabinLevel?: number;
    paxBookedShip?: number;
    cabinsBookedCabinGrade?: number;
    cabinsBookedCabinType?: number;
    cabinsBookedCabinCabinLevel?: number;
    cabinsBookedShip?: number;
    targetCabinsBookedCabinGrade?: number;
    targetCabinsBookedCabinType?: number;
    targetCabinsBookedCabinLevel?: number;
    targetCabinsBookedShip?: number;
    cabinCapacityCabinGrade?: number;
    cabinCapacityCabinType?: number;
    cabinCapacityCabinLevel?: number;
    cabinCapacityShip?: number;
    occupancyCabinGrade?: number;
    occupancyCabinType?: number;
    occupancyCabinLevel?: number;
    occupancyShip?: number;
    revenueCabinGrade?: number;
    revenueCabinType?: number;
    revenueCabinLevel?: number;
    revenueShip?: number;
}

